import { render } from "./CalendarBodyMonth.vue?vue&type=template&id=6e5022de&scoped=true"
import script from "./CalendarBodyMonth.vue?vue&type=script&lang=ts"
export * from "./CalendarBodyMonth.vue?vue&type=script&lang=ts"

import "./CalendarBodyMonth.vue?vue&type=style&index=0&id=6e5022de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e5022de"

export default script